import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { ProductModelInstance } from 'src/store/_models/product';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';
import { TestIDs } from 'src/constants/testIDs.constants';
import { bottomBarEditTestID } from 'src/helpers/testIDs.helper';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { TOAST_IDS } from '@photosi/rn-components/toast/Toast.constants';
import { PrimaryButton } from '@photosi/rn-components/buttons/primary-button/PrimaryButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { style } from './BottomBarEditSaveButton.style';
import { useCallback } from 'react';

export const BottomBarEditSaveButton = observer(({ activeProduct }: { activeProduct: ProductModelInstance }) => {
  const {
    i18n,
    project,
    toastStore: { hideToast },
    dynamicModal: { closeModal },
  } = useStore();
  const handleClose = useCallback(async () => {
    if (project.activeProject) {
      const userImageArea = project.activeProject.userImageAreasWithCropAlert.find(userImageArea => {
        return userImageArea.productId === activeProduct.id;
      });
      if (userImageArea?.userImage?.id) {
        project.activeProject.deactivateCropAlert([userImageArea.userImage.id]).then(() => {
          if (!project.activeProject?.hasAnyImageWithCropAlert) {
            hideToast(TOAST_IDS.CutsCheckAlert);
          }
        });
      }
    }
    amplitude.trackEvent(AnalyticsEvents.modifyPhoto.saveClick);

    project.setActiveTool(ACTIVE_TOOLS.frame);

    project.activePreview?.unloadAll(); // unloads imageEditor

    closeModal();
  }, []);

  return (
    <View style={style.ctaWrapper}>
      <PrimaryButton
        onPress={handleClose}
        focusGroup={FocusGroups.BOTTOM_SHEET}
        focusId={bottomBarEditTestID(TestIDs.SAVE_AND_CLOSE)}
        focusOrder={0}
        text={i18n.t('actions:save_and_return')}
      />
    </View>
  );
});

BottomBarEditSaveButton.displayName = 'BottomBarEditSaveButton';
